import { apiClient } from './api';

/**
 * Exactly what POST /v1/invites/lookup returns (invitationService.getByToken).
 *
 * Corrected in REV-520: this previously declared `role` as a string (it is an
 * object), a non-nullable `organization` (the API can send null), and `status`
 * + `inviter` fields the API never sends at all.
 */
export interface InvitationDetails {
  id: string;
  email: string;
  organization: {
    id: string;
    name: string;
    slug: string;
  } | null;
  role: {
    slug: string;
    name: string;
  } | null;
  expires_at: string;
}

/** What POST /v1/invites/accept returns in `data`. */
export interface AcceptInvitationResult {
  organization_id: string;
  organization_name: string;
  role: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  requestId?: string;
}

// Public Invitation API (for accepting invitations).
//
// REV-878: the token always travels in the request BODY. In a path it lands in
// every proxy access log on the way and in Referer headers.
export const invitationService = {
  // Get invitation details by token (public). invitationController returns the
  // invitation flat in `data`, not wrapped as `data.invitation` (REV-520).
  getByToken: async (token: string) => {
    const response = await apiClient.post<ApiResponse<InvitationDetails>>('/v1/invites/lookup', {
      token,
    });
    return response.data;
  },

  // Accept invitation (requires auth). invitationService.acceptInvitation
  // returns { organization_id, organization_name, role }; `message` lives on
  // the envelope, not inside `data` (REV-520 bug class).
  accept: async (token: string) => {
    const response = await apiClient.post<ApiResponse<AcceptInvitationResult>>(
      '/v1/invites/accept',
      { token }
    );
    return response.data;
  },
};

export default invitationService;
